import type ResizableHandle from './ResizableHandle.js'
import type ResizablePanel from './ResizablePanel.js'
import { createContext } from '@lit/context'

export interface ResizableRegistrationContext {
  registerPanel: (panel: ResizablePanel) => void
  unregisterPanel: (panel: ResizablePanel) => void
  registerHandle: (handle: ResizableHandle) => void
  unregisterHandle: (handle: ResizableHandle) => void
  notifyPanel: (panel: ResizablePanel) => void
  notifyHandle: (handle: ResizableHandle) => void
  pointerDown: (handle: ResizableHandle, event: PointerEvent) => void
  pointerMove: (handle: ResizableHandle, event: PointerEvent) => void
  pointerEnd: (handle: ResizableHandle, event: PointerEvent) => void
  keyboardResize: (handle: ResizableHandle, event: KeyboardEvent) => void
  cancelHandleInteraction: (handle: ResizableHandle) => void
}

export const resizableContext = createContext<ResizableRegistrationContext | undefined>(
  Symbol('nord-resizable-context'),
)

/** Replays a missed context request when an SSR child upgrades before its parent provider. */
export function requestResizableContextAfterParentUpgrade(
  host: HTMLElement,
  requestContext: () => void,
) {
  const parent = host.parentElement
  const registry = host.ownerDocument.defaultView?.customElements
  if (!parent || !registry || !parent.localName.includes('-')) {
    return
  }

  void registry.whenDefined(parent.localName).then(() => {
    if (host.isConnected && host.parentElement === parent) {
      requestContext()
    }
  }, () => {})
}
